import React from 'react';
import styled from 'styled-components';
import Experience from '../components/Experience';
import Certifications from '../components/Certifications';

const PageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const ExperiencePage = () => (
  <PageStack>
    <Experience />
    <Certifications />
  </PageStack>
);

export default ExperiencePage;

